import { Component } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-new-experience-modal',
  imports: [],
  templateUrl: './new-experience-modal.component.html',
  styleUrl: './new-experience-modal.component.scss',
  standalone:true,
})
export class NewExperienceModalComponent {
  constructor(private activeModal: NgbActiveModal,  private modelService: NgbModal) {}
   dismiss() {
    this.modelService.dismissAll();
  }

  openScheduleTrainingModal() {
       const url = `https://calendly.com/fatima-j-webbtree/webbtree-hiring-projects?back=1`;
  window.open(url, '_blank');
  }
}
